import './Subcategories.scss';
import Component from './Subcategories.js';
export default Component;
